module.exports = __webpack_public_path__ + "img/bdg_create.76ccb0e5.svg";